import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import Card from 'react-bootstrap/Card';
import './Card.css'; // Import your CSS file

const MyCard = () => {
  return (
    <div className='main'>
    <div className='mt-5'>
    <div style={{ textAlign: "center" }}></div>
      <h2 className='heading'>Our Expertise</h2>
      <br></br>
      <br></br>
      <div className="card-container">
        <Card className="card1">
          <Card.Img variant="top" src="Image\Artificial-Intelligence.jpeg" alt="Card image" />
          <Card.Body>
            <Card.Title>Artificial Intelligence (AI)</Card.Title>
            <Card.Text>
              We specialize in developing AI-driven applications and solutions that enhance efficiency, automate processes.
            </Card.Text>
          </Card.Body>
        </Card>

        <Card className="card1">
          <Card.Img variant="top" src="Image\cloud computing.jpg" alt="Card image" />
          <Card.Body>
            <Card.Title>Cloud Computing</Card.Title>
            <Card.Text>
              Embrace the limitless possibilities of the Azure & google cloud with our comprehensive cloud computing services. 
            </Card.Text>
          </Card.Body>
        </Card>

        <Card className="card1">
          <Card.Img variant="top" src="Image\migration.jpg" alt="Card image" />
          <Card.Body>
            <Card.Title>Migration of Applications to Cloud</Card.Title>
            <Card.Text>
              Seamlessly transition your applications to the Azure, AWS & Google cloud with our expert migration services.
            </Card.Text>
          </Card.Body>
        </Card>

        <Card className="card1">
          <Card.Img variant="top" src="Image\website.jpg" alt="Card image" />
          <Card.Body>
            <Card.Title>Digital Web Solutions</Card.Title>
            <Card.Text>
            We craft responsive and visually appealing websites optimized for performance and user experience.
            </Card.Text>
          </Card.Body>
        </Card>

        <Card className="card1">
          <Card.Img variant="top" src="Image\mobile1.webp" alt="Card image" />
          <Card.Body>
            <Card.Title>Smart App Development</Card.Title>
            <Card.Text>
            We design and develop cutting-edge mobile applications tailored to your business needs.
            </Card.Text>
          </Card.Body>
        </Card>

        <Card className="card1">
          <Card.Img variant="top" src="Image\azure.jpg" alt="Card image" />
          <Card.Body>
            <Card.Title>Azure Cloud Infrastructure Services</Card.Title>
            <Card.Text>
            We offer comprehensive Azure cloud solutions, including virtual machines, scalable storage, networking, databases, and security.
            </Card.Text>
          </Card.Body>
        </Card>

      </div>
      <br></br>
    </div>
    </div>
  );
};

export default MyCard;
